<template>
    <div>
    <NavBar></NavBar>
    <Breadcrumb></Breadcrumb>
    <div class="container">
      <div class="row mt-3">
        <div class="col-lg-3">
          <SideBar></SideBar>
        </div>
        <div class="col-lg-9 content">
          <div class="pages"><div>     
    <section id="ContactForm" class="section section-2">
    <div class="container">
        <h1 class="main-title">{{ $t("jobApplication") }}</h1>
        <b-alert v-if="isSubmitted" show variant="success">{{ $t("yourApplicationHasBeenSent") }}</b-alert>
        <form>
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="userName">{{ $t('jobAppFormLabels.name') }}</label>
                        <input
                                type="text"
                                id="userName"
                                class="form-control col-sm-8"
                                v-model="userData.name"
                                required>
                    </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="userSurame">{{ $t('jobAppFormLabels.surname') }}</label>
                        <input
                                type="text"
                                id="userSurname"
                                class="form-control col-sm-8"
                                v-model="userData.surname"
                                required>
                    </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="dateOfBirth">{{ $t('jobAppFormLabels.birthDate') }}</label>
                        <input
                                type="date"
                                id="dateOfBirth"
                                class="form-control col-sm-8" 
                                v-model="userData.dateOfBirth"
                                required>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="education">{{ $t("education") }}</label>
                        <select id="education" class="form-control col-sm-8" v-model="userData.education" required>
                            <option>{{ $t("jobAppFormLabels.education.education_1") }}</option>
                            <option>{{ $t("jobAppFormLabels.education.education_2") }}</option>
                            <option>{{ $t("jobAppFormLabels.education.education_3") }}</option>
                            <option>{{ $t("jobAppFormLabels.education.education_4") }}</option> 
                        </select>
                    </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="homeAddress">{{ $t('jobAppFormLabels.homeAddress') }}</label><br>
                        <!-- Interpolation between <textarea>{{ test }}</textarea> doesn't work!-->
                        <textarea
                            id="homeAddress"
                            rows="5"
                            class="form-control col-sm-8"
                            v-model="userData.homeAddress"
                            required></textarea>
                     </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="location">{{ $t('jobAppFormLabels.city') }}</label>
                        <select id="location" class="form-control col-sm-8" v-model="selectedLocation" required>
                            <option v-for="(location, key) in locations" :key="key"> {{ location }} </option>   
                        </select>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="town">{{ $t('jobAppFormLabels.town') }}</label>
                        <input
                                type="text"
                                id="town"
                                class="form-control col-sm-8"
                                v-model="town"
                                required>
                    </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="militaryStatus">{{ $t("militaryStatus") }}</label>
                        <select id="militaryStatus" class="form-control col-sm-8" v-model="userData.militaryStatus" required>
                            <option>{{ $t("jobAppFormLabels.militaryStatus.military_1") }}</option>
                            <option>{{ $t("jobAppFormLabels.militaryStatus.military_2") }}</option>
                            <option>{{ $t("jobAppFormLabels.militaryStatus.military_3") }}</option>
                        </select>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="phoneNumber">{{ $t('jobAppFormLabels.phoneNumner') }}</label>
                        <input
                                type="number"
                                id="phoneNumber"
                                class="form-control col-sm-8"
                                v-model="userData.phoneNumber"
                                required>
                    </div>
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                            <div class="col"></div>
                            <div class="col-xs-12 col-md-8 offset-md-4">
                               
                         <!--mine  -->     <vue-recaptcha
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="this.sitekey">
          </vue-recaptcha>
                            </div>
                        </div>
            
                    </div>


                   
                   

                </div>
            </div>
                    
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                  <div class="col"></div>
                    <div class="col-xs-12 col-md-8 offset-md-4">
                        <button class="btn btn-primary w-50" @click.prevent="submitted">{{ $t('jobAppFormLabels.applyButton') }}</button>
                    </div>
                </div>
            </div>
        </form>
        <hr>
        <p><small>{{ $t('contactFormLabels.requiredFields') }}</small></p>
        <p><small>{{ $t('contactFormLabels.note') }}</small></p>

    </div>

    </section>
      
          </div>
        </div>
      </div>
    </div>
    
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios';

/* mine*/ 
import VueRecaptcha from 'vue-recaptcha';
import NavBar from "@/components/shared/NavBar.vue";
import Breadcrumb from "@/components/shared/Breadcrumb.vue";
import SideBar from "@/components/shared/SideBar.vue";
import Footer from "@/components/shared/Footer.vue";
    export default {
        data () {
            return {
                pageSlug: this.$route.params.slug,
                errors: [],
                FormResult: null,
                userData: {
                    email: '',
                    name: '',
                    surname: '',
                    dateOfBirth: '',  
                    education: '',
                    homeAddress: '',
                    militaryStatus: '', 
                    oggIDCard: '',
                    phoneNumber: '',
                    location: ''
                },
                isSubmitted: false,
                locations: ['ADANA', 'ADIYAMAN', 'AFYONKARAHİSAR', 'AĞRI', 'AMASYA', 'ANKARA', 'ANTALYA', 'ARTVİN', 'AYDIN', 'BALIKESİR', 'BİLECİK', 'BİNGÖL', 'BİTLİS', 'BOLU', 'BURDUR', 'BURSA', 'ÇANAKKALE', 'ÇANKIRI', 'ÇORUM', 'DENİZLİ', 'DİYARBAKIR', 'EDİRNE', 'ELAZIĞ', 'ERZİNCAN', 'ERZURUM', 'ESKİŞEHİR', 'GAZİANTEP', 'GİRESUN', 'GÜMÜŞHANE', 'HAKKARİ', 'HATAY', 'ISPARTA', 'MERSİN', 'İSTANBUL', 'İZMİR', 'KARS', 'KASTAMONU', 'KAYSERİ', 'KIRKLARELİ', 'KIRŞEHİR', 'KOCAELİ', 'KONYA', 'KÜTAHYA', 'MALATYA', 'MANİSA', 'KAHRAMANMARAŞ', 'MARDİN', 'MUĞLA', 'MUŞ', 'NEVŞEHİR', 'NİĞDE', 'ORDU', 'RİZE', 'SAKARYA', 'SAMSUN', 'SİİRT', 'SİNOP', 'SİVAS', 'TEKİRDAĞ', 'TOKAT', 'TRABZON', 'TUNCELİ', 'ŞANLIURFA', 'UŞAK', 'VAN', 'YOZGAT', 'ZONGULDAK', 'AKSARAY', 'BAYBURT', 'KARAMAN', 'KIRIKKALE', 'BATMAN', 'ŞIRNAK', 'BARTIN', 'ARDAHAN', 'IĞDIR', 'YALOVA', 'KARABüK', 'KİLİS', 'OSMANİYE', 'DÜZCE'],
                town: '',
                selectedLocation: ''
            }
        },
          head: {
  
    script: [
      { type: 'text/javascript', src: 'https://www.google.com/recaptcha/api.js?render=6LddAv0ZAAAAALHGf3A6bBlhY84b0I5hUd0eKddS', async: true, body: true}, // Insert in body
      // with shorthand
      { t: 'application/ld+json', i: '{ "@context": "http://schema.org" }' },
      // ...
    ]
  },
        
   components: {
    NavBar,
    Breadcrumb,
    SideBar,
    VueRecaptcha,
    Footer
  },
        methods: {
            submitted(e) {
                this.isSubmitted = true;
                /*mine*/ this.$refs.invisibleRecaptcha.execute()
                e.preventDefault();
                let config = {
                    headers: {
                        "Authorization": "Token 720a063643fda845dde8ada5208083f6",
                        "Content-Type": "application/json"
                    }
                }
                let myData = {
                    content: 'Name' + '=' + this.userData.name + '&' 
                    + 'Surname' + '=' + this.userData.surname + '&' 
                    + 'SateOfBirth' + '='  + this.userData.dateOfBirth + '&' 
                    + 'Education' + '='  + this.userData.education + '&' 
                    + 'HomeAddress' + '='  + this.userData.homeAddress + '&' 
                    + 'Location' + '=' + this.selectedLocation + '&' 
                    + 'Town' + '=' + this.town + '&' 
                    + 'MilitaryStatus' + '=' + this.userData.militaryStatus + '&' 
                    + 'oggIDCard' + '='  + this.userData.oggIDCard 
                    + 'PhoneNumber' + '=' + this.userData.phoneNumber + '&',
                    application: this.$application,
                    language: this.$t("languageCode"),
                    dynamicField: '5fe455c05f0f9e3348cc95c9'
                };
                let secondData = JSON.stringify(myData);
                console.log(secondData);

                axios.post('http://api.aerosec.com.tr/forms', secondData, config)
                .then(response =>(this.FormResult = response.data))
                 .catch(error => {
                    this.errors.push(error);
                    console.log(error)

                })
            },
    /* mine */onVerify: function (response) {
      console.log('Verify: ' + response)
    },
    onExpired: function () {
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
        }
    }
   
</script>

<style>



</style>
